// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"108":"37789f7581da69bb6aa4","452":"b8f2b5a28297159c3c98"}[chunkId] + ".js";
};